import { useAuth } from "@workos-inc/authkit-react";
import AuthLoading from "@/components/AuthLoading";
import LoginPage from "@/components/LoginPage";

interface RequireAuthProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

/**
 * Gates its children behind a WorkOS session. Waits for AuthKit to finish
 * restoring any existing session (so a signed-in user doesn't briefly see the
 * login page on a cold start), then shows the landing page for signed-out users.
 */
const RequireAuth: React.FC<RequireAuthProps> = ({ children, fallback }) => {
    const { isLoading, user } = useAuth();

    if (isLoading) {
        return <AuthLoading message="Checking your session..." />;
    }

    if (!user) {
        return <>{fallback ?? <LoginPage />}</>;
    }

    return <>{children}</>;
}

export default RequireAuth;
